import {StyleSheet} from "aphrodite/no-important"

export const styles = StyleSheet.create({
    container: {
        backgroundColor: "white",
        borderStyle: "solid",
        borderRadius: "0px",
        borderWidth: "1px",
        borderColor: "#bababa"
    },
    years: {
        display: "grid",
        gridTemplateColumns: "80px 80px 80px",
    },
    yearItem : {
        padding: "10px",
        userSelect: "none",
        textAlign: "center",
        ":hover": {
            backgroundColor: "#f4f4f4",
            fontWeight: "bold"
        }
    },
    selectedYearItem : {
        padding: "10px",
        userSelect: "none",
        textAlign: "center",
        fontSize: "14px",
        ":hover": {
            cursor: "pointer",
            fontWeight: "bold"
        },
    },
    slider: {
        display: "grid",
        gridTemplateColumns: "auto 80px auto",
        backgroundColor: "#efefef",
        alignItems: "center"
    },
    button: {
        padding: "10px",
        userSelect: "none",
        textAlign: "center",
        ":hover": {
            cursor: "pointer",
            fontWeight: "bold"
        },
        fontSize: "14px"
    }
});


// WEBPACK FOOTER //
// ./src/components/YearPickerStyles.ts